import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import audioImage from "common/images/audiofile.png";

import { saveContentSvc } from "./contentSvc";

import lstModules from 'common/json/lstModules.json';
const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;

function ContentSlider(props) {
  const { contentDtls, closeSlider, updateKey, mediaTypes, orientations, contentBasePath } = props;

  const [editLoader, setEditLoader] = useState("none");
  const [editOpacity, setEditOpacity] = useState(1);

  const [contentId, setContentId] = useState(0);
  const [content, setContent] = useState("");
  const [mediaTypeId, setMediaTypeId] = useState(10);
  const [layoutTypeId, setLayoutTypeId] = useState(10);
  const [flgMediaTypeAutoSelected, setFlgMediaTypeAutoSelected] = useState(true);
  const [flgOrientationAutoSelected, setOrientationAutoSelected] = useState(true);
  const [csvTags, setCsvTags] = useState("");


  const [contentFile, setContentFile] = useState(null);
  const [contentPath, setContentPath] = useState(window.appURL + "/no-image.png");
  const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
  const imgBasePath = "https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=";
  // const imgBasePath = `${httpURL}:8280/sms/student/docs/view?imgPath=`;



  useEffect(() => {
    // console.log("ContentSlider called, contentDtls", contentDtls, ", contentBasePath", contentBasePath);
    if (contentDtls && Object.keys(contentDtls).length > 0) {
      // console.log("image path", imgBasePath + contentBasePath + contentDtls.fileNm || window.appURL + "/no-image.png")
      setContentId(contentDtls.contentId || 0);
      setContent(contentDtls.content || "");
      setMediaTypeId(contentDtls.mediaTypeId || 0);
      setLayoutTypeId(contentDtls.layoutTypeId || 0);
      setCsvTags(contentDtls.csvTags || "")
    }
    if (contentDtls.mediaTypeId !== 30) {
      // setContentPath(imgBasePath + contentBasePath + "/" + contentDtls.fileNm || window.appURL + "/no-image.png");
      setContentPath(imgBasePath + contentBasePath + "/" + contentDtls.fileNm || window.appURL + "/no-image.png");
    } else {
      setContentPath(audioImage);
    }
  }, [contentDtls]);

  const handleMediaTypeChange = (value) => {
    setMediaTypeId(value);
  };

  const handleOrientationChange = (value) => {
    setLayoutTypeId(value);
  };


  const handleFileClick = () => {
    // Trigger file input click
    document.getElementById("media_fileId").click();
  };

  const onError = () => {
    setContentPath(window.appURL + "/no-image.png");
  };


  const handleFileChange = (e) => {
    // console.log("handleFileChange called");
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setContentFile(file);
      const fileType = file.type.split("/")[0];
      if (fileType === "image") {
        setMediaTypeId(10);  // Set media type to image
        const img = new Image();
        img.onload = () => {
          // Check image orientation based on width and height
          const aspectRatio = img.width / img.height;

          // Check if aspect ratio is between 0.95 and 1.05 for square
          if (aspectRatio > 0.95 && aspectRatio < 1.05) {
            setLayoutTypeId(30);  // Square
          } else if (img.width > img.height) {
            setLayoutTypeId(10);  // Landscape
          } else if (img.width < img.height) {
            setLayoutTypeId(20);  // Portrait
          }
        };
        img.src = URL.createObjectURL(file);
        setContentPath(URL.createObjectURL(file)); // Show image preview
      } else if (fileType === "video") {
        setMediaTypeId(20);  // Set media type to video
        const video = document.createElement('video');
        video.onloadedmetadata = () => {
          // const videoDuration = video.duration; 
          // alert(videoDuration);
          // Check video orientation based on width and height
          const aspectRatio = video.videoWidth / video.videoHeight;
          // Check if aspect ratio is between 0.95 and 1.05 for square
          if (aspectRatio > 0.95 && aspectRatio < 1.05) {
            setLayoutTypeId(30);  // Square
          } else if (video.videoWidth > video.videoHeight) {
            setLayoutTypeId(10);  // Landscape
          } else if (video.videoWidth < video.videoHeight) {
            setLayoutTypeId(20);  // Portrait
          }

        };
        video.src = URL.createObjectURL(file);
        setContentPath(URL.createObjectURL(file)); // Show video preview
      } else if (fileType === "audio") {
        setMediaTypeId(30);  // Set media type to audio
        setLayoutTypeId(30);  // Set layout type to default for audio (Square)
        setContentPath(audioImage); // Placeholder for audio
      } else {
        toast.error("Unsupported file type. Please select a valid image, video, or audio file.");
      }
    }
  };



  const saveContent = () => {
    // console.log("saveContent called");
    const contentObj = {
      contentId,
      content,
      mediaTypeId,
      layoutTypeId,
      csvTags
    }
    // console.log("contentObj", contentObj);
    if (contentFile) {
      // console.log("media file ready to upload:", contentFile);
      setEditLoader("block");
      setEditOpacity(0.5);
      saveContentSvc(contentObj, contentFile, saveContentResponse);
    } else if (contentPath) {
      // console.log("Using existing image from imgPath.");
      fetch(contentPath)
        .then(response => response.blob())
        .then(blob => {
          const file = new File([blob], contentPath.split('/').pop(), { type: blob.type });
          setEditLoader("block");
          setEditOpacity(0.5);
          saveContentSvc(contentObj, file, saveContentResponse); // Use the created file
        })
        .catch(error => {
          console.error("Error fetching the image:", error);
          toast.error("Failed to process the displayed file. Please upload a new one.");
        });
    } else {
      // console.log("No media file selected.");
    }
  }


  const saveContentResponse = (data) => {
    // console.log("saveContentResponse called, data", data);
    if (data.status === "Success") {
      toast.success(data.message);
      updateKey();
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setEditLoader("none");
    setEditOpacity(1);
  }

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };


  return (
    <div >
      <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
        <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
      </button>
      <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
        <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
      </div>
      <div className="col-md-12 col-xs-12 col-centered padding-remove "
        style={{
          cursor: (editLoader === "none") ? 'pointer' : 'none',
          pointerEvents: (editLoader === "none") ? 'auto' : 'none',
          opacity: editOpacity
        }}>
        <div className="col-sm-12 col-md-12 padding-remove"
          style={{ width: '94%', margin: '3% ', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
          <form
            id="editContentForm"
            className='form form-horizontal'
            style={{ height: "80vh", maxHeight: "600px", overflowX: 'hidden', padding: "20px 20px 5px 20px", }}
          >
            <div className="form-group col-md-12 " style={{ padding: "5px 0" }}>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                  Content Name:
                </label>
                <div className='col-md-6 col-sm-6 col-xs-12  '>
                  <input
                    type="text"
                    className="form-control"
                    minLength={5}
                    maxLength={20}
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    placeholder='annual fest image students'
                  ></input>
                </div>
              </div>


              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                  Tags:
                </label>
                <div className='col-md-6 col-sm-6 col-xs-12  '>
                  <input
                    type="text"
                    className="form-control"
                    maxLength={100}
                    value={csvTags}
                    onChange={(e) => setCsvTags(e.target.value)}
                    placeholder='annual fest, students'
                  ></input>
                </div>
              </div>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                  Media:
                </label>
                <div className='col-md-6 col-sm-6 col-xs-12  '>
                  <div
                    style={{
                      width: '200px',
                      height: '200px',
                      border: '2px solid #ddd', // Border of 200px * 200px
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      overflow: 'hidden',
                    }}
                  >
                    <input
                      type="file"
                      id="media_fileId"
                      name="media file"
                      onChange={handleFileChange}
                      // onChange={(e) => handleFileChange(e.target.files[0])}
                      className="hidden"
                      accept="image/*,video/*,audio/*"
                    />
                    {mediaTypeId === 10 ? (
                      <img
                        src={contentPath}
                        alt="img"
                        onClick={handleFileClick}
                        height="160"
                        width="160"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                        onError={onError}
                      />
                    ) : mediaTypeId === 20 ? (
                      <video
                        src={contentPath}
                        onClick={handleFileClick}
                        height="160"
                        width="160"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                        onError={onError}
                        muted
                        preload="metadata"
                      />
                    ) : (
                      <img
                        src={contentPath}
                        alt="img"
                        onClick={handleFileClick}
                        height="160"
                        width="160"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                        onError={onError} />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6" style={{ padding: "7px 0 0 0" }}>
                  Media Type:
                </label>
                <div className="col-md-3 col-sm-3 col-xs-9" style={{ paddingTop: "7px" }}>
                  {mediaTypes.get(mediaTypeId)}
                </div>
              </div>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6" style={{ padding: "7px 0 0 0" }}>
                  Layout:
                </label>
                <div className="col-md-3 col-sm-3 col-xs-9" style={{ paddingTop: "7px" }}>
                  {orientations.get(layoutTypeId)}
                </div>
              </div>


              <div className='col-sm-10   padding-remove' style={{ height: "50px", marginTop: "30px" }}>
                <div className="col-sm-2 col-md-2  padding-remove pull-right">
                  <button type="button" className="btn btn-info " onClick={() => saveContent()} >Save</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div >
  )
}

export default ContentSlider